import { makeStyles } from '@mui/styles'

const useStyles = makeStyles(
  ({ breakpoints, layout, palette, shadow, spacing, typography }) => {
    const highlightMenu = {
      '&:after': {
        display: 'block',
        content: '""',
        width: '100%',
        height: 3,
        backgroundColor: palette.secondary.main,
        position: 'absolute',
        left: 0,
        bottom: 0,
      },
    }

    return {
      header: {
        boxShadow: shadow.default,
        height: layout.header.height,
        display: 'flex',
        justifyContent: 'space-between',
        backgroundColor: palette.background.paper,
        color: palette.secondary.main,
        alignItems: 'center',
        padding: spacing(0, 4),
        borderRadius: '0 0 6px 6px',
      },
      headerDefault: {
        justifyContent: 'center',
      },
      headerLeft: {
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        width: '20%',
        height: '100%',
      },
      headerLeftDefault: {
        justifyContent: 'center',
        width: '100%',
      },
      logo: {
        height: '65%',
        width: 'auto',
      },
      headerMiddle: {
        display: 'flex',
        justifyContent: 'center',
        width: '60%',
        height: '100%',
        alignItems: 'center',
      },
      navigation: {
        display: 'flex',
        alignItems: 'center',
        height: '100%',
        [breakpoints.down('md')]: {
          flexDirection: 'column',
          height: 'auto',
          alignItems: 'flex-start',
          padding: spacing(6, 0),
          '& > a': {
            padding: spacing(3, 4),
          },
        },
      },
      navLink: {
        fontSize: typography.body1.fontSize,
        position: 'relative',
        textTransform: 'uppercase',
        color: palette.secondary.main,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        textDecoration: 'none',
        height: '100%',
        padding: spacing(0, 4),
        [breakpoints.down('md')]: {
          width: '100%',
          justifyContent: 'flex-start',
        },
        '&:hover': { ...highlightMenu },
      },
      isActive: {
        [breakpoints.up('md')]: {
          ...highlightMenu,
        },
        [breakpoints.down('md')]: {
          backgroundColor: palette.background.medium,
        },
      },
      isDisabled: {
        opacity: 0.5,
        pointerEvents: 'none',
      },
      headerRight: {
        display: 'flex',
        justifyContent: 'flex-end',
        width: '20%',
        height: '100%',
      },
      searchField: {
        marginLeft: spacing(2),
      },
      drawer: {
        position: 'relative',
        width: '80%',
        minWidth: layout.header.responsiveMenu.minWidth,
        boxShadow: `${shadow.default} !important`,
        borderRadius: '0 6px 6px 0 !important',
      },
      closeDrawer: {
        position: 'absolute !important',
        top: 0,
        right: 0,
      },
    }
  },
)

export default useStyles
